import { AdminType, APIPost, APIPut, APIUrl, StatusCode } from "api/protocols";
import { ICartTransaction } from "redux/reducers/models/cart";
import { IKind } from "redux/reducers/models/transaction";

interface IPostTransaction {
  kind: IKind;
  amount: number;
  order_id: number;
  payment_option_id: number;
  gift_card_code?: string;
  gift_card_pin?: string;
  account_id?: number;
  guest_name?: string;
  room_number?: string;
  credit_book_id?: number;
  deposit_id?: number;
  exchange_collect?: boolean;
}

export interface IPostTransactionResponse {
  status: StatusCode;
  data: ICartTransaction;
}

export async function PostTransaction(
  params: IPostTransaction,
  useGlobalLoader: boolean,
) {
  return await APIPost<ICartTransaction>(APIUrl(AdminType.FacilityAdmin, "/order/transaction"), params, useGlobalLoader);
}

export async function PutTransaction(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/transaction"), params, useGlobalLoader);
}

export interface IPutCapture {
  payment_intent_id: string | number;
  transaction_id: number;
  exchange_collect?: boolean | Record<string, any>;
}

export async function PutCapture(params: IPutCapture, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/transaction/capture"), params, useGlobalLoader);
}
export async function PutCancelPaymentIntent(
  params: { payment_intent_id: string | number; transaction_id: number },
  useGlobalLoader: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/order/transaction/cancel"), params, useGlobalLoader);
}
